import React, { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { twJoin } from 'cn'
import { useTranslation } from 'next-i18next/pages'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useGetCoursePageUrl } from 'modules/course/hooks/use-course-path-url'
import useStepRouter from 'modules/course/hooks/use-step-router'
import { CourseLectureId } from 'modules/course/types/course-lecture-interface'
import { CourseStepEnum } from 'modules/course/types/course-step-type'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

interface CourseNeedCompleteAssignmentScreenProps {
  blockingAssignmentId?: CourseLectureId
}

export const CourseNeedCompleteAssignmentScreen = ({
  blockingAssignmentId,
}: React.PropsWithChildren<CourseNeedCompleteAssignmentScreenProps>): ReactNode => {
  const { t } = useTranslation()

  const coursePath = useGetCoursePageUrl()
  const { findStepById, findStep } = useStepRouter()

  let step = findStepById(blockingAssignmentId)

  if (!step?.available) {
    step = findStep()
  }

  const href = step
    ? `/school/course/${coursePath}/${CourseStepEnum.assignment}/${step.id}`
    : `/school/course/${coursePath}`

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(`course__info-screen--need-to-complete-assignment`)}
      text={t('course.lecture.assignment.complete_previous_assignment')}
      buttons={
        <Button
          variant="primary"
          className={twJoin(
            'border-THEME-secondary! bg-THEME-secondary! text-THEME-block-background! hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled!',
            `font-bold`,
            addPublicCustomClassNamePrefix([
              'course__button',
              'course__button--primary',
              'course__button--go-to-uncompleted-assignment',
            ]),
          )}
          render={<LinkWithoutPrefetch href={href} />}
        >
          {t('course.lecture.assignment.go_to_assignment_button')}
        </Button>
      }
    />
  )
}
